import {
  AngularSignaturePadModule,
  NgSignaturePadOptions,
  SignaturePadComponent,
} from '@almothafar/angular-signature-pad';
import { Component, input, model, ViewChild, effect } from '@angular/core';
import { getImageBlobFromUrl } from '@shared/utils';

import { ButtonComponent } from '@shared/components/button';

@Component({
  selector: 'app-signature-container',
  imports: [AngularSignaturePadModule, ButtonComponent],
  templateUrl: './signature-container.component.html',
})
export class SignatureContainerComponent {
  @ViewChild('signature')
  signaturePad!: SignaturePadComponent;
  areSignatureTabsPristine = model<boolean>();

  isDisabled = input<boolean>(false);

  signaturePadOptions: NgSignaturePadOptions = {
    minWidth: 1,
    dotSize: 1,
    canvasWidth: 650,
    canvasHeight: 150,
    canvasBackground: 'rgb(255, 255, 255)',
  };

  constructor() {
    effect(() => {
      if (this.isDisabled()) {
        this.signaturePad?.off();
        this.signaturePadOptions.minWidth = this.isDisabled() ? 0 : 1;
        this.signaturePadOptions.dotSize = this.isDisabled() ? 0 : 1;
      }
    });
  }

  resizeCanvas() {
    if (!this.signaturePad) return;

    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    const canvas = this.signaturePad.getCanvas();
    if (!canvas) return;

    canvas.width = 650 * ratio;
    canvas.height = 150 * ratio;

    canvas.style.width = '650px';
    canvas.style.height = '150px';

    // Scale the context to account for device pixel ratio
    const ctx = canvas.getContext('2d');
    if (ctx) ctx.setTransform(ratio, 0, 0, ratio, 0, 0);

    this.signaturePad.redrawCanvas();
    this.signaturePad.changeBackgroundColor('rgb(255, 255, 255)');
  }

  getImageBlob(): Blob {
    const dataUrl = this.signaturePad.toDataURL();
    const imageBlob = getImageBlobFromUrl(dataUrl);
    return imageBlob;
  }

  clearSignature() {
    if (this.signaturePad) {
      this.signaturePad.clear();
      this.areSignatureTabsPristine.set(true);
    }
  }
  onSignatureDraw() {
    if (this.isDisabled()) return;
    this.areSignatureTabsPristine.set(false);
  }
}
